import { Pagination } from 'antd';
import { useIsMobile } from '../../hooks/useIsMobile';

interface Props {
  current: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
  /** 桌機版的外距／對齊（手機一律置中）。 */
  className?: string;
}

/** 照片格線下的分頁列（媒體庫、挑圖 Drawer 共用）：手機用精簡版，桌機顯示「共 N 張」。 */
export default function MediaPager({ current, pageSize, total, onChange, className = 'mt-6 text-center' }: Props) {
  const mobile = useIsMobile();
  return (
    <Pagination
      className={mobile ? 'mt-4 flex justify-center' : className}
      simple={mobile}
      size={mobile ? 'small' : undefined}
      current={current}
      pageSize={pageSize}
      total={total}
      showSizeChanger={false}
      showTotal={mobile ? undefined : (t) => `共 ${t.toLocaleString()} 張`}
      onChange={onChange}
    />
  );
}
